import { configurePaymentService } from './paymentService';

// Export des services
export {
  configurePaymentService
};

// Configurer les services au chargement
configurePaymentService(); 